import React from 'react'
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';

import {makeStyles, Grid, Paper, Typography} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(3, 0, 0, 3),
    padding: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down('md')]: {
      // paddingLeft: theme.spacing(3)
    },
  }
}));

const CountdownSoal = (props) => {
    const classes = useStyles();
    const history = useHistory();

    // Countdown
    const {initialMinute = 15,initialSeconds =0} = props;
    const [minutes, setMinutes ] = useState(initialMinute);
    const [seconds, setSeconds ] =  useState(initialSeconds);
    useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
          setSeconds(seconds - 1);
      }
      if (seconds === 0) {
          if (minutes === 0) {
              clearInterval(myInterval)
          } else {
              setMinutes(minutes - 1);
              setSeconds(59);
          }
      } 
      if (seconds === 1 && minutes === 0) {
        return (
          Swal.fire({
            icon: "success",
            title: "Jawaban Tersimpan!",
            text: "Hasil Ujian akan muncul jika sudah dinilai ^_^",
          }),
          history.push('/user/beranda')
        )
      }
    }, 1000)
    return ()=> {
        clearInterval(myInterval);
      };
    });

    return (
      <Grid item xs={3} md={2}>
        <Paper className={classes.paper} elevation={3} style={{height: 80}}>
          { minutes === 0 && seconds === 0
              ? null
              : <Typography variant="h4">{minutes}:{seconds < 10 ?  `0${seconds}` : seconds} </Typography>
          }
        </Paper>
      </Grid>
    )
}

export default CountdownSoal